import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as rccActions from "../../../actions/rccActions";

import Button from "../generic/Button";

class SpectroSelectButton extends Component {
    handleStartSelectClick = () => {
        if (!this.props.spectro.isSelected) {
            this.props.dispatchStartSelectSpectroAction();
        }
    };

    render() {
        if (!this.props.connected || this.props.spectro.isSelected) {
            return "";
        }

        return <Button label={<Translate value="spectroTab.selectSpectro" />} onClick={this.handleStartSelectClick} />;
    }
}

const mapStoreToProps = (store) => {
    return {
        connected: store.rcc.connected,
        spectro: store.spectro.spectro
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchStartSelectSpectroAction: () => {
            dispatch(rccActions.spectroIsSelectedAction());
        }
    };
};

export default SpectroSelectButton = connect(mapStoreToProps, mapDispatchToProps)(SpectroSelectButton);
